import React, { Component } from 'react';
import Header from '../../components/Header';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import './BusinessIntelligence.css';

class BusinessIntelligence extends Component {
  constructor(props) {
    super(props);

    this.state = {
      error: ''
    }
  }
  validateUrl = (url) => {
    let re = /^(http|https):\/\/(([a-zA-Z0-9$\-_.+!*'(),;:&=]|%[0-9a-fA-F]{2})+@)?(((25[0-5]|2[0-4][0-9]|[0-1][0-9][0-9]|[1-9][0-9]|[0-9])(\.(25[0-5]|2[0-4][0-9]|[0-1][0-9][0-9]|[1-9][0-9]|[0-9])){3})|localhost|([a-zA-Z0-9\-\u00C0-\u017F]+\.)+([a-zA-Z]{2,}))(:[0-9]+)?(\/(([a-zA-Z0-9$\-_.+!*'(),;:@&=]|%[0-9a-fA-F]{2})*(\/([a-zA-Z0-9$\-_.+!*'(),;:@&=]|%[0-9a-fA-F]{2})*)*)?(\?([a-zA-Z0-9$\-_.+!*'(),;:@&=\/?]|%[0-9a-fA-F]{2})*)?(\#([a-zA-Z0-9$\-_.+!*'(),;:@&=\/?]|%[0-9a-fA-F]{2})*)?)?$/;
    if (re.test(url)) return null;
    else this.state.error = 'Intelligence Report Coming Soon';
  }

  render() {
    let bi_url = '';
    if (this.props.vendor.selected !== null) {
      bi_url = this.props.vendor.selected.bi_url;
    }
    this.validateUrl(bi_url);
    return (
      <div>
				<Header
          handleLogout={this.props.handleLogoutClick}
					title="BUSINESS INTELLIGENCE" />
          {this.state.error &&
            <p className="bi__error">{this.state.error}</p>
          }
          {!this.state.error &&
            <iframe
              width="100%"
              height="800"
              src={bi_url}
              frameborder="0"
              allowFullScreen="true"/>
          }
      </div>
    );
  }
}

export default withRouter(
  connect(state => ({
    campaign: state.campaign,
    location: state.location,
    vendor: state.vendor,
    modal: state.modal,
    promotion: state.promotion,
  }))(BusinessIntelligence)
);



/** WEBPACK FOOTER **
 ** ./src/containers/BusinessIntelligence/index.js
 **/